import Joi from "joi";
import FormValidationResult from "../../../../common/utils/validation/types/form-validation-result";
import formValidationService from "../../../../common/utils/validation/form-validation.service";
import CargoAddressType from "../../../../common/types/cargo-address-type";
import CargoAddressTypeSelectOption from "./types/cargo-address-type-select-option";

const validateAddressType = (
  addressTypeSelectOption: CargoAddressTypeSelectOption | null,
): FormValidationResult => {
  const validValues = Object.values(CargoAddressType);

  const validationSchema = Joi.string()
    .valid(...validValues)
    .required();

  const addressType = addressTypeSelectOption?.value;

  return formValidationService.validate(addressType, validationSchema);
};

const validateStreet = (street: string): FormValidationResult => {
  const validationSchema = Joi.string().trim().min(2).max(50).required();

  return formValidationService.validate(street, validationSchema);
};

const validateHouseNumber = (houseNumber: string): FormValidationResult => {
  const validationSchema = Joi.string().trim().max(10).required();

  return formValidationService.validate(houseNumber, validationSchema);
};

const validateApartmentNumber = (
  apartmentNumber: string,
): FormValidationResult => {
  const validationSchema = Joi.string().trim().allow("").max(10).required();

  return formValidationService.validate(apartmentNumber, validationSchema);
};

const validateTown = (town: string): FormValidationResult => {
  const validationSchema = Joi.string().trim().min(2).max(50).required();

  return formValidationService.validate(town, validationSchema);
};

const validateCountry = (country: string): FormValidationResult => {
  const validationSchema = Joi.string().trim().min(2).max(50).required();

  return formValidationService.validate(country, validationSchema);
};

const validateZipCode = (zipCode: string): FormValidationResult => {
  const validationSchema = Joi.string().trim().min(2).max(10).required();

  return formValidationService.validate(zipCode, validationSchema);
};

const validateDescription = (description: string): FormValidationResult => {
  const validationSchema = Joi.string().trim().max(100).required();

  return formValidationService.validate(description, validationSchema);
};

const cargoAddressFormValidationService = {
  validateAddressType,
  validateStreet,
  validateHouseNumber,
  validateApartmentNumber,
  validateTown,
  validateCountry,
  validateZipCode,
  validateDescription,
};

export default cargoAddressFormValidationService;
